import React from "react";
import Icon from "../../../components/AppIcon";

const CustomerInfoCard = ({ customer }) => {
  const infoItems = [
    { icon: "User", label: "Name", value: customer?.name || "—" },
    { icon: "Phone", label: "Phone", value: customer?.phone_number || "—" },
    {
      icon: "CreditCard",
      label: "Aadhaar",
      value: customer?.aadhaar_number || "—",
    },
    { icon: "Hash", label: "CIN", value: customer?.cin || "—" },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        Customer Information
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {infoItems?.map((item, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={item?.icon} size={18} className="text-primary" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-xs text-muted-foreground">{item?.label}</p>
              <p className="text-sm md:text-base font-medium text-foreground truncate">
                {item?.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerInfoCard;
